$(document).ready(function () {
	let selects = $('[data-product] .options-area select[data-vg-toggle="select"]');

	selects.each(function () {
		let nSelect = this.nextSibling,
			dataPrices = [];

		nSelect.setAttribute('data-id', this.id);

		$(this).find('option').each(function () {
			dataPrices.push($(this).data('price'))
		});

		$(nSelect).find('.option').each(function (index) {
			let title = document.createElement('span');
			title.classList.add('title');
			title.innerHTML = this.innerHTML;

			let price = document.createElement('span');
			price.classList.add('price');
			price.innerHTML = '+ ' + output_money(Number(dataPrices[index]));

			this.innerHTML = '';

			this.append(title);
			this.append(price);
		});
	});

	setTimeout(() => {
		selects.trigger('change');
	}, 300);

	$('[data-product] .form-options [name="options[]"]').change(function () {
		let $container = $(this).closest('.options-area');
		let $form = $(this).closest('.form-options');
		let $product = $(this).closest('[data-product]');

		let basePrice = parseFloat($product.find('[data-price-basic]').data('price-basic'));


		let options = $product.find('.form-options').serializeArray();
		let selected = Array.from(options).map((v) => v.value);

		let additionals = selected.map(v => {
			return parseFloat($form.find(`[value="${v}"]`).data('price') || 0)
		});

		let additionalsPrice = additionals.reduce((a, b) => a + b);
		let resultPrice = basePrice + additionalsPrice;

		if (additionalsPrice > 0) {
			$container.find('.additional span').text('+ комплектующие на сумму ' + output_money(additionalsPrice));
		} else {
			$container.find('.additional span').text('комплектующие не выбраны');
		}

		$container.find('.total-area [data-total]').text(output_numbers(resultPrice, 2));
	});
});
